import React from "react";

export default function WashSofaLogo({ white = false, size = "md" }) {
  const height = size === "sm" ? 40 : size === "lg" ? 70 : 52;

  return (
    <img
      src="/washsofa-logo.png"
      alt="WashSofà"
      style={{
        height: `${height}px`,
        width: "auto",
        objectFit: "contain",
        display: "block",
      }}
    />
  );
}
